import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getGoToFairePosCTA } from "./shared";

export const LinkingPosIA: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => {
    return getAnswer(context, strictLocalize).getTitle();
  },

  descriptionBuilder: (context) => {
    return getAnswer(context, strictLocalize).getDescription();
  },

  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getGoToFairePosCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getGoToFairePosCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => LINKING_YOUR_POS(strictLocalize),
    getDescription: () => [TO_SET_UP_YOUR_POS_INTEGRATION(strictLocalize)],
  };
};

const LINKING_YOUR_POS = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Linking your POS",
    description: {
      text: "Title for the answer of Linking POS issue",
    },
  });

const TO_SET_UP_YOUR_POS_INTEGRATION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can set up your POS integration by clicking the user-icon button in the upper-right corner of the retailer portal and selecting the “Connect My POS” option. You can read more about the process in the help center article. Please contact us if you need any further help.",
    description: {
      text: "Description for the answer of Linking POS issue. POS stands for Point of Sale.",
    },
  });
